import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { IconButton, Stack } from "@mui/material";

import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import { TableLayout } from '../../../layout/TableLayout';
import { EditStartupValoration } from './EditStartupValoration';
import {selectValorationStartup} from '../../../../store/startupValoration/startupValorationSlice.js'
import { deleteStartupValoration } from '../../../helpers/startupValoration';
import { numberFormat } from '../../../../helpers/numberFormat';
import { toSpanishDate } from '../../../../helpers/dateFormat';



export const StartupValorationTable = ({ rows, setReloadData }) => {

    const { t } = useTranslation('global');
    const [openEdit, setOpenEdit] = useState(false);
    const dispatch = useDispatch();

    const columns = [
        {
            field: 'startupName',
            headerName: t('valorationStartup.startupName'),
            minWidth: 220,
            flex: 1,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'valuationDate',
            headerName: t('valorationStartup.valuationDate'),
            minWidth: 170,
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => toSpanishDate(params.row.valuationDate)
        },
        {
            field: 'participationValuation',
            headerName: t('valorationStartup.participationValuation'),
            minWidth: 220,
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => numberFormat(params.row.participationValuation)
        },
        {
            field: 'action',
            headerName: t('partnerlist.columnActions'),
            maxWidth: 90,
            align: 'center',
            headerAlign: 'center',
            flex: 0,
            sortable: false,
            renderCell: (params) => {
                return (<Stack direction='row' gap={0}>
                    <IconButton color='secondary' onClick={() => onEditClick(params)}>
                        <EditRoundedIcon />
                    </IconButton>

                    <IconButton color='secondary' onClick={() => onDeleteClick(params)}>
                        <DeleteOutlineRoundedIcon />
                    </IconButton>
                </Stack>
                )
            }
        }
    ];

    const onEditClick = (e) => {
        dispatch(selectValorationStartup(e.row))
        setOpenEdit(true)
    }

    const onDeleteClick = async (e) => {
        await deleteStartupValoration(e.row, t('delete.successMsg'), t('delete.errorMsg'), t('delete.cancelButton'), t('delete.confirmButton'), t('delete.deleteConfirm'))
        setReloadData(prevState => !prevState)
    }

    return (
        <>
            <TableLayout
                rows={rows.map(v => ({...v, startupName: v.startup.name}))}
                columns={columns}
                title='startupValoration'
            />
            {
                openEdit &&
                <EditStartupValoration setHidden={setOpenEdit} setReloadData={setReloadData} />
            }
        </>
    )
}